(function (global) {
  'use strict';

  var COMPONENT_NAME = 'vl-floating-product-card-shortcode';
  var SHORTCODE_SELECTOR = '[data-vl-floating-product-card-shortcode]';
  var LINK_SELECTOR = '[data-vl-floating-product-card-link]';
  var LABEL_SELECTOR = '[data-vl-floating-product-card-cta-label]';

  function parseBoolean(value, fallback) {
    if (value == null || value === '') return Boolean(fallback);
    var normalized = String(value).trim().toLowerCase();
    if (normalized === 'true' || normalized === '1' || normalized === 'yes' || normalized === 'on') return true;
    if (normalized === 'false' || normalized === '0' || normalized === 'no' || normalized === 'off') return false;
    return Boolean(fallback);
  }

  function readDataValue(element, datasetKey, attributeName) {
    if (element && typeof element.getAttribute === 'function') {
      var attributeValue = element.getAttribute(attributeName);
      if (attributeValue != null) return attributeValue;
    }
    var data = element && element.dataset ? element.dataset : {};
    return data[datasetKey];
  }

  function parseShortcodeConfig(element) {
    var handle = String(readDataValue(element, 'productHandle', 'data-product-handle') || '').trim();
    if (!handle) return null;

    return {
      handle: handle,
      buttonLabel: String(readDataValue(element, 'buttonLabel', 'data-button-label') || '').trim() || 'Shop Now',
      showDesktop: parseBoolean(readDataValue(element, 'showDesktop', 'data-show-desktop'), false),
      showMobile: parseBoolean(readDataValue(element, 'showMobile', 'data-show-mobile'), true)
    };
  }

  function productViewUrl(handle, routesRoot) {
    var root = String(routesRoot || '/');
    if (root.slice(-1) !== '/') root += '/';
    return root + 'products/' + encodeURIComponent(String(handle || '')) + '?view=vl-floating-product-card';
  }

  function applyVisibilityClasses(element, config) {
    element.classList.add('vl-floating-product-card');
    element.classList.toggle('vl-floating-product-card--hide-desktop', !config.showDesktop);
    element.classList.toggle('vl-floating-product-card--hide-mobile', !config.showMobile);
  }

  function upgradeShortcode(element) {
    if (!element || !element.ownerDocument) return null;
    if (String(element.tagName || '').toLowerCase() === COMPONENT_NAME) return element;

    var upgraded = element.ownerDocument.createElement(COMPONENT_NAME);
    Array.from(element.attributes || []).forEach(function (attribute) {
      upgraded.setAttribute(attribute.name, attribute.value);
    });
    element.replaceWith(upgraded);
    return upgraded;
  }

  function initShortcodes(root) {
    var scope = root && root.querySelectorAll ? root : global.document;
    if (!scope || !scope.querySelectorAll) return [];
    var shortcodes = Array.from(scope.querySelectorAll(SHORTCODE_SELECTOR));
    if (scope.matches && scope.matches(SHORTCODE_SELECTOR)) shortcodes.unshift(scope);
    return shortcodes.map(upgradeShortcode).filter(Boolean);
  }

  var HTMLElementBase = global.HTMLElement || class {};

  class VlFloatingProductCardShortcode extends HTMLElementBase {
    connectedCallback() {
      if (this.dataset.vlFloatingProductCardLoaded === 'true' || this.requestController) return;

      var config = parseShortcodeConfig(this);
      if (!config) {
        this.hidden = true;
        this.dataset.vlFloatingProductCardError = 'missing-product-handle';
        console.warn('[VL floating product card] Shortcode requires data-product-handle.');
        return;
      }

      applyVisibilityClasses(this, config);
      if (!config.showDesktop && !config.showMobile) {
        this.hidden = true;
        this.dataset.vlFloatingProductCardLoaded = 'true';
        return;
      }

      this.hidden = false;
      this.setAttribute('aria-busy', 'true');
      this.requestController = new AbortController();
      var routesRoot = global.Shopify && global.Shopify.routes ? global.Shopify.routes.root : '/';
      var self = this;

      global.fetch(productViewUrl(config.handle, routesRoot), {
        credentials: 'same-origin',
        signal: this.requestController.signal
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Product not found: ' + config.handle);
          return response.text();
        })
        .then(function (html) {
          self.innerHTML = html;
          var link = self.querySelector(LINK_SELECTOR);
          var label = self.querySelector(LABEL_SELECTOR);
          if (!link || !label) throw new Error('Invalid floating product card response.');

          var productTitle = String(link.dataset.vlFloatingProductCardProductTitle || '').trim();
          label.textContent = config.buttonLabel;
          link.setAttribute('aria-label', config.buttonLabel + (productTitle ? ': ' + productTitle : ''));
          self.dataset.vlFloatingProductCardLoaded = 'true';
          self.removeAttribute('aria-busy');
          self.requestController = null;
          self.dispatchEvent(new CustomEvent('vl:floating-product-card-loaded', {
            bubbles: true,
            detail: { handle: config.handle }
          }));
        })
        .catch(function (error) {
          self.requestController = null;
          if (error && error.name === 'AbortError') return;
          self.hidden = true;
          self.removeAttribute('aria-busy');
          self.dataset.vlFloatingProductCardError = 'product-request-failed';
          console.warn('[VL floating product card] Failed to load product.', error);
        });
    }

    disconnectedCallback() {
      if (this.requestController) this.requestController.abort();
      this.requestController = null;
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = {
      parseBoolean: parseBoolean,
      readDataValue: readDataValue,
      parseShortcodeConfig: parseShortcodeConfig,
      productViewUrl: productViewUrl,
      VlFloatingProductCardShortcode: VlFloatingProductCardShortcode
    };
  }

  if (global.customElements && !global.customElements.get(COMPONENT_NAME)) {
    global.customElements.define(COMPONENT_NAME, VlFloatingProductCardShortcode);
  }

  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', function () {
        initShortcodes(global.document);
      });
    } else {
      initShortcodes(global.document);
    }

    global.document.addEventListener('shopify:section:load', function (event) {
      initShortcodes(event.target);
    });
  }
})(typeof window !== 'undefined' ? window : globalThis);
